import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {Theme, Typography} from '@material-ui/core';
import {checkIsAdmin} from '../../utils/checkIsAdmin';
import {getMe} from '../../graphql/auth';

const useStyles = makeStyles((theme: Theme) => ({
    bottomMessage: {
        width: '100%',
        position: 'fixed',
        zIndex: 10,
        bottom: 0,
        padding: theme.spacing(3),
        color: theme.palette.white,
        backgroundColor: theme.palette.primary.main,
    },
}));

export const ContactUsBar = () => {
    const classes = useStyles();
    const isAdmin = checkIsAdmin();
    const meData = getMe();
    const me = meData && meData.data && meData.data.me;
    const isClientBooking = location.pathname.indexOf('/booking/') === 0;

    if((!me && !isClientBooking) || (isAdmin && !isClientBooking)) return null;

    return (
        <div className={classes.bottomMessage}>
            <Typography
                variant={'h3'}
                style={{textAlign: 'center', color: 'white'}}
            >
                Questions? Call us at 1-800-222-4432
            </Typography>
        </div>
    );
};

export default ContactUsBar;